/**
 * sku-search.js
 *
 * Standalone custom element for SKU search.
 * Intercepts form submit, calls Shopify's Predictive Search API with
 * exact-match options (prefix=none, field=variants.sku), and redirects
 * directly to the product page when exactly one result is found.
 * Falls back to a normal form submission (results page) otherwise.
 */

class SkuSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.submitButton = this.querySelector('button[type="submit"]');
  }

  connectedCallback() {
    this.querySelector('form').addEventListener('submit', this.onSubmit.bind(this));
    this.querySelector('form').addEventListener('reset', this.onReset.bind(this));
    this.input.addEventListener('input', this.toggleResetButton.bind(this));
  }

  toggleResetButton() {
    this.resetButton?.classList.toggle('hidden', this.input.value.length === 0);
  }

  onReset() {
    this.input.value = '';
    this.toggleResetButton();
    this.input.focus();
  }

  async onSubmit(event) {
    event.preventDefault();
    debugger;

    const query = this.input.value.trim();
    if (!query) return;

    this.setLoading(true);

    try {
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '2',
        'resources[options][fields]': 'variants.sku',
        'resources[options][prefix]': 'none',
      });

      const response = await fetch(`/search/suggest.json?${params}`);
      debugger;
      if (!response.ok) throw new Error(response.status);

      const json = await response.json();

      debugger;

      const { resources } = json;
      const products = resources?.results?.products ?? [];

      if (products.length === 1) {
        window.location.href = products[0].url;
        return;
      }
    } catch (_) {
      // On any network/parse error fall through to normal submit
    }

    this.setLoading(false);
    this.querySelector('form').submit();
  }

  setLoading(on) {
    this.submitButton.disabled = on;
    this.submitButton.setAttribute('aria-busy', String(on));
  }
}

customElements.define('sku-search', SkuSearch);
